module.exports = __webpack_public_path__ + "img/sr48_samurai01skin_shop.7fa5724c.png";